export default {

	props: {
		/** 宽度 */
		width: {
			type: String
		},
	},

};
